export enum EPaymentItemEarningType {
  HOURLY = "hourly",
  PER_UNIT = "per_unit",
  FLAT_FEE = "flat_fee",
  EXPENSE_REIMBURSEMENT = "expense_reimbursement",
  BONUS = "bonus",
}

export const rateBasedEarningTypes = [
  EPaymentItemEarningType.HOURLY,
  EPaymentItemEarningType.PER_UNIT,
] as const;

export const fixedAmountEarningTypes = [
  EPaymentItemEarningType.FLAT_FEE,
  EPaymentItemEarningType.BONUS,
  EPaymentItemEarningType.EXPENSE_REIMBURSEMENT,
] as const;

export const isRateBasedEarningType = (
  type: EPaymentItemEarningType | undefined
): type is EPaymentItemEarningType.HOURLY | EPaymentItemEarningType.PER_UNIT =>
  type !== undefined &&
  (rateBasedEarningTypes as readonly EPaymentItemEarningType[]).includes(type);

export const isFixedAmountEarningType = (
  type: EPaymentItemEarningType | undefined
): type is
  | EPaymentItemEarningType.FLAT_FEE
  | EPaymentItemEarningType.BONUS
  | EPaymentItemEarningType.EXPENSE_REIMBURSEMENT =>
  type !== undefined &&
  (fixedAmountEarningTypes as readonly EPaymentItemEarningType[]).includes(
    type
  );
